import { Component, DestroyRef, Inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ButtonList } from 'src/app/system-utils/actions-buttons/actions-buttons.component';
import { MiniCardInterface } from '../../interfaces/minicard';
import { FormServices } from 'src/app/services/form.services';
import { StepDataInterface } from 'src/app/system-utils/side-panel/side-panel.component';
import { IconServices } from 'src/app/services/icon.services';
import { Observable } from 'rxjs';
import { DashBoardTypeEnum, GadGetInterface } from '../../interfaces/dashboard';
import { DashboardViewService } from 'src/app/services/dashboard.services';

/*
 * Aberto via NzModalService.create({ nzData, nzViewContainerRef }) —
 * o nzViewContainerRef do dashboard garante que o DashboardViewService
 * injetado aqui seja A MESMA instância (contexto empresa/contrato).
 */
@Component({
    selector: 'mini-card-configuration',
    templateUrl: './mini-card-configuration.component.html',
    styleUrl: './mini-card-configuration.component.scss',
    standalone: false
})
export class MiniCardConfigurationComponent implements OnInit {

  form: FormGroup;
  tabName: string;
  name: string;
  idDashboard: number;
  item: MiniCardInterface;
  stepData: StepDataInterface[] = [];
  icons: Observable<Object[]> = new Observable<Object[]>();
  colorDisable = true;
  newGadGet = false;
  filters: string[];
  typeIcon: { id: string, name: string }[] = [
    {
      id: 'google',
      name: 'Google',
    },
    {
      id: 'svg',
      name: 'SVG'
    },
    {
      id: 'fa',
      name: 'Font Awesome'
    }
  ];

  buttonList: ButtonList[] = [];

  constructor(
    @Inject(NZ_MODAL_DATA) public dataDialog,
    public modalRef: NzModalRef,
    public formBuilder: FormBuilder,
    public formServices: FormServices,
    public iconServices: IconServices,
    private message: NzMessageService,
    public dvs: DashboardViewService,
    private destroyRef: DestroyRef
  ) {

  }

  onQueryChange($event) {
    this.form.get('query').setValue($event);
  }

  get query() {
    return this.form.get('query').value;
  }

  get type() {
    return this.form.get('type').value;
  }

  ngOnInit(): void {

    if (this.dataDialog.item == null) {
      this.newGadGet = true;
    }

    this.item = this.dataDialog.item == null ? {
      title: "",
    } : this.dataDialog.item;

    this.idDashboard = this.dataDialog.idDashBoard;
    this.tabName = this.dataDialog.tabName;

    this.filters = this.dataDialog.filters != null ? this.dataDialog.filters : [];
    this.dvs.addDefaultFilters(this.filters);

    if (this.name == null) {
      this.name = this.dataDialog.name == null ?
        this.idDashboard + "_" + this.tabName + "_" + DashBoardTypeEnum.minicard + "_" + Date.now().toString() :
        this.dataDialog.name;
    }

    this.form = this.formBuilder.group({
      iconColor: new FormControl<any>(null),
      fgColor: new FormControl<any>(null),
      bgColor: new FormControl<any>(null),
      duration: new FormControl<string>(null),
      refresh: new FormControl<number>(null),
      icon: new FormControl<any>(null),
      isCurrency: new FormControl<boolean>(false),
      isIncrease: new FormControl<boolean>(false),
      percentValue: new FormControl<string>(''),
      textValue: new FormControl<string>(''),
      title: new FormControl<string>(''),
      value: new FormControl<string>(''),
      query: new FormControl<string>(null),
      type: new FormControl<any>(null),
      x: new FormControl<number>(null),
      y: new FormControl<number>(null),
      cols: new FormControl<number>(null),
      rows: new FormControl<number>(null)
    });

    this.formServices.refreshFormObject(this.form, this.item);

    this.buttonList.push(
      {
        color: "warn",
        description: "Cancelar",
        action: () => {
          this.sair();
        }
      },
      {
        color: "primary",
        description: "Salvar",
        action: () => {
          this.okFunction();
        }
      });

    this.stepData = [
      {
        buttonList: this.buttonList,
        info: "Determinar as configurações do Mini-Card",
        name: "Nome",
        sideDesc: "Informações",
        title: "Informações",

      },
      {
        buttonList: this.buttonList,
        name: "query",
        sideDesc: "Query",
        title: "Consulta ao Banco de Dados",

      }
    ];

    if (this.form.get('type').value == "svg") {
      this.getIconsInfo('svg');
    }

  }

  okFunction() {

    if (this.form.valid) {

      const query = this.query as string | null;

      if (query == null || query.trim() === '') {
        this.message.error('Informar a query do Mini-Card.');
        return;
      }

      if (query.indexOf('INCREASE') == -1) {
        this.message.error('Não informado o campo INCREASE ( S ou N ) na query.');
        return;
      }

      if (query.indexOf('VALUE') == -1) {
        this.message.error('Não informado o campo VALUE na query.');
        return;
      }

      if (query.indexOf('PERCENTVALUE') == -1) {
        this.message.info('Não informado o campo PERCENTVALUE na query.');
      }

      if (this.newGadGet) {
        let data: MiniCardInterface = JSON.parse(JSON.stringify(this.form.getRawValue()));

        let gadget: GadGetInterface = {
          gridsterItem: {
            cols: 1,
            rows: 1,
            x: 0,
            y: 0
          },
          name: this.name,
          type: DashBoardTypeEnum.minicard,
          minicard: data
        };

        this.modalRef.close(gadget);

      } else {
        this.item = this.form.getRawValue();
        this.modalRef.close(this.item);
      }
    } else {
      this.form.markAllAsTouched();
    }
  }

  /** recebe o VALOR direto do nz-select (antes: MatSelectChange) */
  getIconsInfo(value: string) {
    if (value == 'svg') {
      this.form.get('iconColor').disable();
      this.colorDisable = true;
    } else {
      this.form.get('iconColor').enable();
      this.colorDisable = false;
    }

    this.icons = this.iconServices.getIcons(value);
    // dispara o request; a lista é consumida pelo template via async
    this.icons.pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
  }

  sair() {
    this.modalRef.close();
  }
}
